import React, { FC, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { generateCenteredColumnSpanClassNames } from '../../../../utils/Utils';

interface RecruiteeJobsProps {
  columnWidths?: Array<string>;
}

const createWidget = (setWidget) => {
  setWidget(new window.RTWidget({
    companies: [
      42309,
    ],

    detailsMode: 'recruitee',
    language: 'en',
    departmentsFilter: [],
    themeVars: {
      primary: '#e32a19',
      secondary: '#5c6f78',
      text: '#000',
      textDark: '#37474f',
      fontFamily: '\'GT America Burrow\', sans-serif;',
      baseFontSize: '16px',
    },
    flags: {
      showLocation: true,
      showCountry: true,
      showCity: true,
      showState: true,
      groupByLocation: false,
      groupByState: false,
      groupByDepartment: true,
      groupByCompany: false,
    },
  }));
};

const RecruiteeJobs: FC<RecruiteeJobsProps> = ({ columnWidths }) => {
  const [widget, setWidget] = useState(null);

  useEffect(() => {
    let t;
    if (!widget) {
      t = setInterval(() => {
        if (window.RTWidget) {
          createWidget(setWidget);
          clearInterval(t);
        }
      }, 250);
    }

    return () => {
      clearInterval(t);
    };
  }, []);

  const columnWidthsClassNames = generateCenteredColumnSpanClassNames(columnWidths);

  return (
    <div className="card plain-text-wrapper">
      <div id="recruitee-careers" className={columnWidthsClassNames}>
        <Helmet>
          <script src="https://d10zminp1cyta8.cloudfront.net/widget.js" async/>
        </Helmet>
      </div>
    </div>
  );
};

export default RecruiteeJobs;
